import React from "react";
import DetailTable from "../component/DetailTable";
import Nav from "../component/Nav";
import Contact from "../component/Contact";
import Footer from "../component/Footer";
import Pdf from "../Uifiles/lipapap.pdf";
import SignleProjectDiscription from "../component/SignleProjectDiscription"

export default function Lipapap() {
  return (
    <div className="container-fluid">
      <div className="row">
        <Nav />

        <div className="col-10 offset-1">
          <div className="row">
            
            <SignleProjectDiscription
            type = "WEB DESIGN - FRONT END"
            name = "LIPAPAP"
            dis1= "The LIPAPAP payment gateway website front-end is a dynamic platform that showcases the company's services and features. The website features a modern and responsive design that allows customers to easily navigate through the website on different devices. To enhance user engagement, I incorporated animations and interactive elements that make the website visually appealing and engaging."
            dis2= "To develop the front-end, We used React, a popular JavaScript library for building user interfaces. I also used HTML, CSS, and JavaScript to implement the website's various features and functionalities. I integrated third-party APIs to enable customers to make payments securely through the website."
            youtube = "https://www.youtube.com/embed/ItHbQk9pw2E"
            />

            

      
            <DetailTable
              link=""
              doc=""
              ui={Pdf}
              special="Developed only front end by us."
            />
          </div>
        </div>

        <Contact />
        <Footer />
      </div>
    </div>
  );
}
